import { useAppSelector } from '@app/core/hooks/redux-hooks';
import CellValue from '@app/shared/components/cell-value/CellValue';
import {
  amountRules,
  enteredPercentageViewRules,
} from '@app/shared/components/cell-value/CellValueConfigurations';
import { Alignment } from '@app/shared/enums/alignment.enum';
import { OpmInputsYearDebtInstrumentCalculationResultsPeriodTotalDto } from '@app/shared/models/contracts/opm-calculation-results-dto';
import { translationKeys } from '@locale/setupI18n';
import { FC } from 'react';
import OpmInputHistoricCells from '../../OpmInputHistoricCells';

interface TableRowProps {
  title: translationKeys;
  valueSelector: (
    data: OpmInputsYearDebtInstrumentCalculationResultsPeriodTotalDto
  ) => string | number | undefined;
  toolTipLongTextSelector?: (
    data: OpmInputsYearDebtInstrumentCalculationResultsPeriodTotalDto
  ) => string | number | undefined;
  instrumentId: string;
  isBold?: boolean;
  isPercentage?: boolean;
  isText?: boolean;
}

export const ShareSectionTableRow: FC<TableRowProps> = ({
  title,
  valueSelector,
  instrumentId,
  toolTipLongTextSelector = undefined,
  isBold = false,
  isPercentage = false,
  isText = false,
}) => {
  const results = useAppSelector((state) => state.opmCalculation.calculatedInputs);
  const caseForecasts = Object.entries(results?.forecastDates ?? {});

  return (
    <tr>
      <th className="table-primary__cell--vertical-separator">
        {isBold ? <strong>{title}</strong> : title}
      </th>
      <OpmInputHistoricCells
        indexIdentifier={`${instrumentId}-${title}`}
        renderCell={(historicDate, historicValues) => (
          <CellValue
            value={valueSelector(
              historicValues.shareholderDebtInstrumentsEvents[instrumentId]?.periodTotal
            )}
            titleValue={toolTipLongTextSelector?.(
              historicValues.shareholderDebtInstrumentsEvents[instrumentId]?.periodTotal
            )?.toString()}
            {...(isText ? {} : amountRules)}
            {...(isPercentage ? enteredPercentageViewRules : {})}
            strong={isBold}
            alignment={Alignment.Right}
          />
        )}
      />
      <td>
        <CellValue
          value={valueSelector(
            results.valuationDate.shareholderDebtInstrumentsEvents[instrumentId]?.periodTotal
          )}
          titleValue={toolTipLongTextSelector?.(
            results.valuationDate.shareholderDebtInstrumentsEvents[instrumentId]?.periodTotal
          )?.toString()}
          {...(isText ? {} : amountRules)}
          {...(isPercentage ? enteredPercentageViewRules : {})}
          strong={isBold}
          alignment={Alignment.Right}
        />
      </td>
      {caseForecasts.map(([forecastDate, forecastValues]) => {
        return (
          <td key={forecastDate}>
            <CellValue
              value={valueSelector(
                forecastValues.shareholderDebtInstrumentsEvents[instrumentId]?.periodTotal
              )}
              titleValue={toolTipLongTextSelector?.(
                forecastValues.shareholderDebtInstrumentsEvents[instrumentId]?.periodTotal
              )?.toString()}
              {...(isText ? {} : amountRules)}
              {...(isPercentage ? enteredPercentageViewRules : {})}
              strong={isBold}
              alignment={Alignment.Right}
            />
          </td>
        );
      })}
      <td />
    </tr>
  );
};
